import React from "react";

export default function SQLServer_LEFT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_LEFT</h1>
      <p>This is the SQLServer_LEFT component generated from the SQL JSON.</p>
    </div>
  );
}
